import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[firebirdWebOverlayClose]',
  standalone: false,
})
export class OverlayCloseDirective {
  constructor(private elementRef: ElementRef) {}
  @Output() firebirdWebOverlayClose = new EventEmitter<MouseEvent>();

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: EventTarget | null): void {
    // Angular types $event.target as EventTarget | null; Node.contains() needs a
    // Node, and this guard also covers the null case the original code checked.
    if (!(targetElement instanceof Node)) {
      return;
    }
    if (!this.elementRef.nativeElement.contains(targetElement)) {
      this.firebirdWebOverlayClose.emit(event);
    }
  }
}
